/**
 * Europe Markets Map Interactivity Logic
 */
document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.liv-europe-map-section');
  const popup = document.getElementById('liv-master-popup');
  const pins = document.querySelectorAll('.liv-map-pin');
  const body = document.getElementById('liv-popup-body');
  const arrow = document.getElementById('liv-arrow-template');
  let timer;

  if (!container || !popup) return;

  const marketData = JSON.parse(document.getElementById('liv-market-data').textContent);

  const isTouch = window.matchMedia("(pointer: coarse)").matches || window.innerWidth <= 900;

  const hexTemplate = document.getElementById('liv-hexagon-template');

  const toggle = (show, pin = null, event = null) => {
    clearTimeout(timer);
    
    if (show && pin) {
      const data = marketData[pin.dataset.blockId];
      if (!data) return;
      
      const validLink = (data.link && data.link !== "null") ? data.link : '#';
      
      const footerHtml = `
        <div class="liv-popup-footer">
          <a href="${validLink}" class="liv-popup-btn">${hexTemplate ? hexTemplate.innerHTML : ''}</a>
        </div>
      `;

      body.innerHTML = `
        <div class="liv-popup-header"><h3>${data.title}</h3></div>
        <div class="liv-popup-content">${data.content || ''}</div>
        ${footerHtml}
      `;

      popup.style.left = popup.style.top = ''; 
      popup.classList.add('is-visible');
      
      // Highlight country
      document.querySelectorAll('.liv-map-svg-wrapper svg path').forEach(p => p.classList.remove('is-active'));
      document.querySelectorAll('.liv-map-pin').forEach(p => p.classList.remove('is-active'));

      const countryId = data.countryId?.trim().toUpperCase();
      if (countryId) {
        const paths = document.querySelectorAll(`.liv-map-svg-wrapper svg path[id="${countryId}"], .liv-map-svg-wrapper svg path[data-country="${countryId}"]`);
        paths.forEach(p => p.classList.add('is-active'));
        
        // Find the pin for this country and mark it active
        pin.classList.add('is-active');
      }
    } else {
      timer = setTimeout(() => {
        if (!popup.matches(':hover')) {
          popup.classList.remove('is-visible');
          document.querySelectorAll('.liv-europe-svg path').forEach(p => p.classList.remove('is-active'));
          document.querySelectorAll('.liv-map-pin').forEach(p => p.classList.remove('is-active'));
        }
      }, 3000);
    }
  };

  // Helper to attach same events to multiple elements
  const attachTriggers = (el, pin) => {
    // Hover events for desktop
    el.addEventListener('mouseenter', (e) => toggle(true, pin, e));
    el.addEventListener('mouseleave', () => toggle(false));
    
    // Click events for redirection
    el.addEventListener('click', (e) => {
        const data = marketData[pin.dataset.blockId];
        if (data && data.link && data.link !== "null" && data.link !== "#") {
            window.location.href = data.link;
        } else {
            e.preventDefault();
            e.stopPropagation();
            toggle(true, pin, e);
        }
    });
  };

  // Setup interactions
  pins.forEach(pin => {
    attachTriggers(pin, pin);

    const data = marketData[pin.dataset.blockId];
    if (data && data.countryId) {
      const countryId = data.countryId.trim().toUpperCase();
      // Select all paths with matching ID or data-country attribute within the map wrapper
      const paths = document.querySelectorAll(`.liv-map-svg-wrapper svg path[id="${countryId}"], .liv-map-svg-wrapper svg path[data-country="${countryId}"]`);
      
      paths.forEach(path => {
        path.classList.add('is-market');
        attachTriggers(path, pin);
      });
    }
  });

  // Keep popup open when hovering over it
  popup.addEventListener('mouseenter', () => clearTimeout(timer));
  popup.addEventListener('mouseleave', () => toggle(false));
  
  const closeBtn = document.querySelector('.liv-popup-close');
  if (closeBtn) {
    closeBtn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      popup.classList.remove('is-visible');
      document.querySelectorAll('.liv-europe-svg path').forEach(p => p.classList.remove('is-active'));
      document.querySelectorAll('.liv-map-pin').forEach(p => p.classList.remove('is-active'));
    };
  }

  // Close on clicking outside (for mobile)
  if (isTouch) {
    document.addEventListener('click', (e) => {
        if (popup.classList.contains('is-visible') && !popup.contains(e.target) && !e.target.closest('.liv-map-pin') && !e.target.closest('.is-market')) {
            popup.classList.remove('is-visible');
            document.querySelectorAll('.liv-europe-svg path').forEach(p => p.classList.remove('is-active'));
            document.querySelectorAll('.liv-map-pin').forEach(p => p.classList.remove('is-active'));
        }
    });
  }

  // Open first pin by default
  if (pins.length > 0) {
    toggle(true, pins[0]);
  }
});